import { Select, TextField, TrashButton } from "components/Core"
import { Controller } from "react-hook-form"
import { DAYS_OF_WEEK_NUMBER, HOURS_OF_DAY, UNIT_TIME } from "constants/FORM_CONSTANTS"
import BadgeAlertForm from "components/Core/Form/BadgeAlertForm"

interface IScheduleRulesFields {
  index: number
  control: any
  schedule_rules: any
  errors: any
  title?: any
}

const ScheduleRulesFields = ({ index, control, schedule_rules, errors, title = null }: IScheduleRulesFields) => {
  const remove_schedule_rule = () => schedule_rules.remove(index)

  return (
    <div className="w-full flex flex-col gap-4">      
      <div className="w-full flex flex-row items-center justify-between p-2">
        <h4 className="font-medium">{title ? title : "Regla de agendamiento"} {Number(index + 1)}</h4>
        <TrashButton onClick={remove_schedule_rule} />
      </div>
      <div className="w-full border-b border-[#919191]"></div>
      
      <div className="w-full flex flex-row items-center justify-start px-2">
        <h4 className="font-medium text-sm">Tiempo de recepción</h4>
      </div>
      <Controller
        name={`scheduleRules[${index}].receptionTime.daysOfWeek`}
        defaultValue={schedule_rules.fields[index]?.receptionTime?.daysOfWeek}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Select label="Dias de la semana" multi options={DAYS_OF_WEEK_NUMBER} onChange={onChange} value={value} />
        )}
      />
      <div className="w-full flex flex-col lg:flex-row gap-4">
        <Controller
          name={`scheduleRules[${index}].receptionTime.from`}
          defaultValue={schedule_rules.fields[index]?.receptionTime?.from}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select label="Inicio" options={HOURS_OF_DAY} onChange={onChange} value={value} />
          )}
        />
        <Controller
          name={`scheduleRules[${index}].receptionTime.to`}
          defaultValue={schedule_rules.fields[index]?.receptionTime?.to}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select label="Fín" options={HOURS_OF_DAY} onChange={onChange} value={value} />
          )}
        />
      </div>

      <div className="w-full flex flex-row items-center justify-start px-2 mt-2">
        <h4 className="font-medium text-sm">Tiempo de entrega</h4>
      </div>
      <div className="w-full flex flex-col lg:flex-row gap-4">
        <Controller
          name={`scheduleRules[${index}].deliveryTime.offset.value`}
          defaultValue={schedule_rules.fields[index]?.deliveryTime?.offset?.value}
          control={control}
          render={({ field: { onChange, value } }) => (
            <TextField label="Offset (valor)" onChange={onChange} value={value} type="number" />
          )}
        />
        <Controller
          name={`scheduleRules[${index}].deliveryTime.offset.unit`}
          defaultValue={schedule_rules.fields[index]?.deliveryTime?.offset?.unit}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select label="Offset (unidad)" options={UNIT_TIME} onChange={onChange} value={value} />
          )}
        />
      </div>
      <div className="w-full flex flex-col lg:flex-row gap-4">
        <Controller
          name={`scheduleRules[${index}].deliveryTime.fixedHour`}
          defaultValue={schedule_rules.fields[index]?.deliveryTime?.fixedHour}
          control={control}
          render={({ field: { onChange, value } }) => (
            <Select label="Hora fija" options={HOURS_OF_DAY} onChange={onChange} value={value} />
          )}
        />
        <Controller
          name={`scheduleRules[${index}].deliveryTime.label`}
          defaultValue={schedule_rules.fields[index]?.deliveryTime?.label}
          control={control}
          render={({ field: { onChange, value } }) => (
            <TextField label="Etiqueta" onChange={onChange} value={value} />
          )}
        />
      </div>

      {Boolean(errors?.scheduleRules && errors?.scheduleRules[index]) ? <BadgeAlertForm /> : null}
    </div>
  )
}

export default ScheduleRulesFields
